import { render, staticRenderFns } from "./HazardReport.vue?vue&type=template&id=9719b95c"
import script from "./HazardReport.vue?vue&type=script&lang=js"
export * from "./HazardReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports